export default "__VITE_PUBLIC_ASSET__fc9779e0__"